<div>
    <app-shopping></app-shopping>
</div>